// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"dcb0e65d","453":"22ca7727","541":"1b105c0f"}[chunkId] + ".chunk.js";
};